import React from "react";

import PageHeading from "2g-page-heading";

import { RezervaceTableContent } from "b2b/components/rezervace-table/RezervaceTableContent";

const data = require("b2b-devel/rezervace.json");

export function RezervaceTableContentExample() {
  return (
    <div>
      <PageHeading>RezervaceTableContent</PageHeading>
      <div data-testid="RezervaceTableContent">
        <RezervaceTableContent zdroje={data.zdroje} dny={data.dny} />
      </div>

      <PageHeading>RezervaceTableContent - loading</PageHeading>
      <div data-testid="loading">
        <RezervaceTableContent zdroje={data.zdroje} dny={data.dny} loading />
      </div>

      <PageHeading>RezervaceTableContent - empty data</PageHeading>
      <div data-testid="empty">
        <RezervaceTableContent />
      </div>
    </div>
  );
}

RezervaceTableContentExample.propTypes = {};

export default React.memo(RezervaceTableContentExample);
